import React, { useState } from "react";
import "./form.css";
import emailjs from "@emailjs/browser";
import { Waypoint } from "react-waypoint";
import { Closer } from "../../imgs/svgs/Closer";

export const Form = () => {
  const [visibleForm, setVisibleForm] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [sentModal, setSentModal] = useState(false);
  const formAppear = () => {
    setVisibleForm(true);
  };

  const sendEmail = (event) => {
    event.preventDefault();

    if (!event.target.user_email.value.endsWith("@gmail.com")) {
      alert("Email no valido");
    } else {
      emailjs
        .sendForm(
          "service_m92mdmu",
          "template_owno0mh",
          event.target,
          "y543bs77jeMZXwkij"
        )
        .then((response) => console.log(response))
        .catch((error) => console.log(error));
      event.target.reset();
      setSentModal(true);
      document.body.classList.add("modal-open");
    }
  };

  const handleChange = (event) => {
    setIsChecked(event.target.checked);
    event.target.value = event.target.checked
      ? "quiero hacer publicidad"
      : "no quiero hacer publicidad";
  };

  const handleClose = () => {
    document.body.classList.remove("modal-open");
    setSentModal(false);
  };

  return (
    <div
      className=" w-full h-auto bg-gray-200 py-20 px-0 flex flex-col items-center justify-center "
      id="formulario"
    >
      {sentModal ? (
        <div className="bg-gray-300 w-1/2 h-36 absolute z-20 flex items-center  flex-col ">
          <div className="w-full h-10 flex justify-end">
            <Closer handleClose={handleClose} />
          </div>
          <h1 className="text-2xl">TU MENSAJE FUE ENVIADO CON ÉXITO =D </h1>
          <i class="fa fa-check text-green-600 text-5xl"></i>
        </div>
      ) : null}

      <div className="flex flex-col justify-between items-center my-0 mx-40 w-11/12 h-full md:flex-row ">
        <Waypoint onEnter={formAppear}>
          <div
            className={
              visibleForm
                ? "flex flex-col items-center justify-center mt-6 h-full w-full py-0 mx-4 form-text-animation"
                : "flex flex-col items-center justify-center mt-6 h-full w-full  py-0 mx-4 form-text-animation-invisible"
            }
          >
            <h3 className=" text-4xl mb-6 pb-6 form-text-title-after w-full">
              Envianos un mensaje a través de nuestro Gmail!
            </h3>

            <p className="text-base mb-4">
              Podes decirnos que canción querés escuchar, enviar un mensaje para
              alguien o simplemente pedirnos publicidad con una tarifa de 200
              mil pesos, con menciones diarias en horarios rotativos y micros de
              20/25 segundos de Lunes a Lunes!
            </p>
          </div>
        </Waypoint>

        <Waypoint onEnter={formAppear}>
          <form
            className={
              visibleForm
                ? "form-animation flex flex-col h-full w-auto mt-6 bg-white p-8 "
                : "form-animation-invisible flex flex-col h-full w-auto mt-6 bg-white p-8"
            }
            onSubmit={sendEmail}
          >
            <div>
              <p className="text-2xl mb-2 font-bold">Envianos tu mensaje</p>

              <p className="mb-6 text-base">
                Es importante que coloques bien tus datos para que podamos
                contactarnos en caso de que sean necesario!
              </p>
            </div>

            <input
              type="text"
              placeholder="Nombre"
              className=" py-3 px-0 mb-6 outline-none border-0 border-b-4 text-base border-orange-400 focus:border-orange-600"
              name="user_name"
              maxLength={25}
              required
            />
            <input
              type="text"
              placeholder="Email"
              className=" py-3 px-0 mb-6 outline-none border-0 border-b-4 text-base border-orange-400 focus:border-orange-600"
              name="user_email"
              required
            />
            <input
              type="number"
              placeholder="Numero"
              className=" py-3 px-0 mb-6 outline-none border-0 border-b-4 text-base border-orange-400 focus:border-orange-600"
              name="user_number"
              required
            />

            <textarea
              placeholder="mensaje"
              className="py-3 px-0  outline-none border-0 border-b-4 border-orange-400 focus:border-orange-600 mb-6 text-base h-40 resize-y"
              name="user_message"
              maxLength={1000}
              required
            />
            <label className="container-checkbox flex flex-row justify-center items-center text-base mt-8">
              <input
                type="checkbox"
                name="user_advertising"
                className=" w-5 h-5"
                id="checkbox"
                checked={isChecked}
                onChange={(event) => handleChange(event)}
              />
              <p className="ml-1"> Quiero hacer publicidad </p>
            </label>

            <div className=" mt-4 w-full flex justify-center items-center">
              <button className="button-form py-2 px-8 w-48 h-14 rounded text-base bg-orange-400 text-white border-0 duration-100 button-hover-form">
                Enviar
              </button>
            </div>
          </form>
        </Waypoint>
      </div>
    </div>
  );
};
